@file:Suppress("UnsafeCastFromDynamic")
package chat

/** UI engagement counter, independent of analytics and privacy settings. */
internal object Sharing {
    private val window: dynamic = js("window")
    private val document: dynamic = js("document")
    private const val KEY = "nouveau-chat.share.count.v1"
    private const val SITE_URL = "https://nouveau.chat/"
    private var currentId: String? = null
    private fun shareUrl(): String = currentId?.let { SITE_URL + "?cat=" + it } ?: SITE_URL
    private var count = 0
    private var status: (String) -> Unit = {}
    private fun element(id: String): dynamic = document.getElementById(id)

    fun initialize(onStatus: (String) -> Unit) {
        status = onStatus
        try {
            count = (window.sessionStorage.getItem(KEY) as String?)?.toIntOrNull()?.coerceIn(0, 3) ?: 0
        } catch (_: Throwable) { }
        element("share-site").hidden = count < 3
        element("share-site").onclick = { share() }
        element("share-url").value = shareUrl()
        element("share-select").onclick = { element("share-url").focus(); element("share-url").select() }
    }

    fun photoDisplayed() {
        count = (count + 1).coerceAtMost(3)
        try { window.sessionStorage.setItem(KEY, count.toString()) } catch (_: Throwable) { }
        element("share-site").hidden = count < 3
    }

    fun selectPhoto(id: String?) {
        currentId = id?.takeIf { CatPhoto.isValidId(it) }
        element("share-site").textContent = if (currentId == null) "Partager Nouveau chat ↗" else "Partager ce chat ↗"
        element("share-site").disabled = currentId == null
        element("share-fallback").hidden = true
        element("share-url").value = shareUrl()
    }

    private fun share() {
        val url = shareUrl()
        element("share-url").value = url
        val button = element("share-site")
        if (button.disabled == true) return
        element("share-fallback").hidden = true
        button.disabled = true
        try {
            if (window.navigator.share != null) {
                val data = js("({})")
                data.title = "Nouveau chat"
                data.text = "Ce chat vous attend."
                data.url = url
                window.navigator.share(data).then { _: dynamic -> button.disabled = false }
                    .catch { error: dynamic ->
                        button.disabled = false
                        if (error?.name != "AbortError") manualCopy()
                    }
            } else if (window.navigator.clipboard?.writeText != null) {
                window.navigator.clipboard.writeText(url).then { _: dynamic ->
                    button.disabled = false
                    status("Lien de ce chat copié.")
                }.catch { _: dynamic -> button.disabled = false; manualCopy() }
            } else { button.disabled = false; manualCopy() }
        } catch (_: Throwable) { button.disabled = false; manualCopy() }
    }

    private fun manualCopy() {
        element("share-fallback").hidden = false
        element("share-url").focus()
        element("share-url").select()
        status("Vous pouvez copier ce lien pour partager ce chat.")
    }
}
